module.exports = __webpack_public_path__ + "static/media/4.63fce10c.jpg";